import styled from 'styled-components';
import Colors from 'library/constants/colors';

export const Label = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 17px 18px 17px 25px;
  background: ${(props) => (props.selected ? `${Colors.violet}` : `${Colors.shade07}`)};
  // opacity: ${(props) => (props.selected ? 0.8 : 1)};
  cursor: pointer;
  //pointer-events: ${(props) => (props.selected ? 'none' : 'inherit')};
  width: 100%;
  margin-bottom: 4px;
  border-radius: 4px;
  box-sizing: border-box;
`;

export const Icon = styled.i`
  font-size: 32px;
  background: ${(props) => (props.selected ? `${Colors.shade08}` : 'none')};
  width: 17px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: ${(props) => (props.selected ? `${Colors.violet}` : `${Colors.shade05}`)};
`;

export const Img = styled.img`
  width: 40px;
  height: 40px;
  background: black;
  border-radius: 4px;
  margin-left: 17px;
`;

export const Text = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: ${(props) => (props.selected ? `${Colors.shade08}` : `${Colors.shade02}`)};
  margin-left: 20px;
`;

export const SetContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 4px;
  margin-left: 17px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Container = styled.div`
  //margin-bottom: 25px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: baseline;
`;

export const StyledLabel = styled.div`
  font-weight: 900;
  width: 120px;
`;

export const ValueContainer = styled.div`
  margin-bottom: 25px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: baseline;
  flex-wrap: wrap;
`;
